import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaPlus, FaTrash } from "react-icons/fa";
import { EspdRequirementGroupDto, EspdRequirementResponseDto } from "../../../../autogen/bff-api";
import { EspdRequirementGroupForm } from "./EspdRequirementGroupForm";

interface Props {
  group: EspdRequirementGroupDto;
  responses: Map<string, EspdRequirementResponseDto>;
  instanceCount: number;
  onResponseChange: (requirementId: string, value: string | boolean | number | null, instanceIndex?: number | null) => void;
  onMetadataChange?: (requirementId: string, field: string, value: string | null, instanceIndex?: number | null) => void;
  onAddInstance: (group: EspdRequirementGroupDto) => void;
  onRemoveInstance: (group: EspdRequirementGroupDto, index: number) => void;
  readOnly?: boolean;
  parentIndicatorValue?: boolean | null;
  isValidating?: boolean;
}

export const EspdRepeatableGroupForm = ({
  group,
  responses,
  instanceCount,
  onResponseChange,
  onMetadataChange,
  onAddInstance,
  onRemoveInstance,
  readOnly,
  parentIndicatorValue,
  isValidating,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      {Array.from({ length: instanceCount }, (_, i) => (
        <Box key={`${group.id}_i${i}`} mb="2">
          <Flex alignItems="center" justifyContent="space-between" mb="1">
            <Text fontSize="xs" color="smMuted" fontWeight="medium">
              {t("espd_entry_number", { number: i + 1 })}
            </Text>
            {!readOnly && instanceCount > 1 && (
              <Button
                size="xs"
                variant="ghost"
                colorScheme="red"
                leftIcon={<FaTrash />}
                onClick={() => onRemoveInstance(group, i)}
              >
                {t("espd_remove_entry")}
              </Button>
            )}
          </Flex>
          <EspdRequirementGroupForm
            group={group}
            responses={responses}
            onResponseChange={onResponseChange}
            onMetadataChange={onMetadataChange}
            readOnly={readOnly}
            parentIndicatorValue={parentIndicatorValue}
            instanceIndex={i}
            isValidating={isValidating}
          />
        </Box>
      ))}
      {!readOnly && (
        <Button size="sm" variant="outline" colorScheme="teal" leftIcon={<FaPlus />} onClick={() => onAddInstance(group)} mt="1" mb="4">
          {t("espd_add_entry")}
        </Button>
      )}
    </Box>
  );
};
